<template>
  <div class="passwordetail">
    <div class="passwordetail_title">
      <p>收藏</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "mycollect"
}
</script>

<style scoped>

</style>